<template>
	<BaseCard class="flex items-center gap-4 py-2 pr-5 pl-2" alt>
		<ItemIcon :src="src" :name="name" :preloader="preloader || undefined" alt />
		<div class="min-w-0 flex-1">
			<div class="text-label-secondary truncate text-xs font-medium uppercase">
				{{ collection }}
			</div>
			<div class="text-label-primary mt-1 truncate text-sm capitalize">
				{{ name }}
			</div>
		</div>
		<div class="inline-flex flex-col items-end">
			<div
				class="text-label-secondary mt-1 text-right text-xs font-medium uppercase"
			>
				{{ chance }}%
			</div>
			<CoinPrice :price="price" class="mt-1" />
		</div>
	</BaseCard>
</template>
<script setup lang="ts">
import CoinPrice from './CoinPrice.vue'
import BaseCard from './BaseCard.vue'
import ItemIcon from './ItemIcon.vue'
import BaseCheckbox from './BaseCheckbox.vue'

defineProps<{
	src: string
	collection: string
	name: string
	price: number
	chance: number
	preloader?: string | null
}>()
</script>
